const topSecFade = (() => {

  const fadeElem = document.querySelectorAll('.js-sec-fade');
  if (fadeElem.length > 0) {

    for (let i = 0; i < fadeElem.length; i++) {
      gsap.set(fadeElem[i], { opacity: 0, y: 40, });

      gsap.to(fadeElem[i], {
        opacity: 1,
        y: 0,
        duration: 1.0,
        ease: "power1.out",
        scrollTrigger: {
          trigger: fadeElem[i],
          start: 'top 70%'
        }
      });
    }

  }

})();
export default topSecFade;